import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function ArticlePreview() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              Latest Basetao Spreadsheet Articles
            </h2>
            <p className="text-sm text-foreground-600">
              In-depth guides, reviews, and tutorials to help you shop smarter.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all overflow-hidden"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <span className="text-xs text-foreground-400 mb-2">{article.date} &middot; {article.readTime}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  Read Article <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}